const NAV_ITEMS = [
  { anchor: 'spread', label: 'So sánh Spread', icon: 'ri-bar-chart-2-line' },
  { anchor: 'swap', label: 'So sánh Swap', icon: 'ri-moon-line' },
  { anchor: 'product', label: 'Thông số sản phẩm', icon: 'ri-information-line' },
];

export default function StudioNav({ onSelect }: { onSelect: (anchor: string) => void }) {
  return (
    <div className="flex flex-wrap items-center gap-2 rounded-2xl border border-slate-200/80 bg-white p-2">
      {NAV_ITEMS.map((item) => (
        <button
          key={item.anchor}
          type="button"
          onClick={() => onSelect(item.anchor)}
          className="flex items-center gap-2 whitespace-nowrap rounded-xl px-4 py-2.5 text-sm font-semibold text-slate-600 transition-colors hover:bg-violet-50 hover:text-violet-700"
        >
          <i className={`${item.icon} text-base`} />
          {item.label}
        </button>
      ))}
      <span className="ml-auto hidden items-center gap-1.5 pr-2 text-[11px] text-slate-400 sm:flex">
        <i className="ri-information-line" />
        Chọn một mục để so sánh
      </span>
    </div>
  );
}